import React from 'react';

interface ExpenseItemData {
    id: number;
    description: string;
    amount: number;
    paidBy: string;
    splitCount: number;
}

interface ExpenseItemProps {
    expense: ExpenseItemData;
    onRemove: (id: number) => void;
}

export const ExpenseItem: React.FC<ExpenseItemProps> = ({ expense, onRemove }) => {
    return (
        <div className="expense-item">
            <div className="expense-info">
                <div className="expense-description">{expense.description}</div>
                <div className="expense-meta">
                    <span className="expense-payer">{expense.paidBy}</span>
                    <span className="expense-separator">•</span>
                    <span className="expense-amount">{expense.amount.toLocaleString('ko-KR')}원</span>
                    <span className="expense-separator">•</span>
                    <span className="expense-split-count">{expense.splitCount}명</span>
                </div>
            </div>
            <button
                className="remove-button"
                onClick={() => onRemove(expense.id)}
            >
                ✕
            </button>
        </div>
    );
};
